<template lang="pug">
  .loader
    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>

</template>

<script>
import debug from 'debug'
// import { mapActions, mapState } from 'vuex'

let log = debug('component:Loader')

export default {
  name: 'loader',
  props: {
    // propName: {
    //   type: String,
    //   default: 'text'
    // }
  },
  data () {
    return {}
  },
  mounted () {
    log('Mounted')
  },
  computed: {
    // ...mapState('tasks', ['allTasks'])
  },
  methods: {
    // ...mapActions('tasks', ['syncTask'])
  },
  components: {},
}
</script>

<style scoped lang="scss">
.loader {
  width: 100vw;
  height: 100vh;
  background: $black;
  position: relative;
  z-index: 10000;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 6px;
  border: 6px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
